<template>
    <q-input
        v-model="internalValue"
        :name="name"
        :label="label"
        outlined
        dense
        v-bind="$attrs"
    >
        <template v-slot:append>
            <q-icon
                name="colorize"
                class="cursor-pointer"
                :style="{ color: internalValue }"
            >
                <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                >
                    <q-color v-model="internalValue" format-model="hex" />
                </q-popup-proxy>
            </q-icon>
        </template>
    </q-input>
</template>

<script>
import { ref, watch } from "vue";

export default {
    name: "ColorPickerWrapper",
    props: {
        modelValue: String,
        name: String,
        label: String,
    },
    emits: ["update:modelValue"],
    setup(props, { emit }) {
        const internalValue = ref(props.modelValue || "#000000");

        watch(
            () => props.modelValue,
            (val) => {
                internalValue.value = val;
            },
        );

        watch(internalValue, (val) => {
            emit("update:modelValue", val);
        });

        return {
            internalValue,
        };
    },
};
</script>
